export default (date: Date) => {
  if (!date) return false;
  if (isNaN(new Date(date).getTime())) return false;

  const now = Date.now();
  const input = new Date(date).getTime();
  const diff = input - now;

  return diff >= 0 && diff <= 24 * 60 * 60 * 1000;
};
